import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of, catchError, map, switchMap } from 'rxjs';
import { GiftsService } from './gifts.service';
import { IGiftRedeem } from '@app/gifts/models/gift-redeem.interface';
import { IGiftCode } from '@app/gifts/models/gift-code.interface';
import { GiftCodeAssignmentStatus } from '@app/gifts/models/gift-code-assignment-status.enum';
import { IGift } from '@app/gifts/models/gift.interface';

@Injectable({
  providedIn: 'root'
})
export class GiftRedeemResolverService implements Resolve<IGiftRedeem> {

  constructor(private giftsService: GiftsService) { }

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<IGiftRedeem | null> {
    const giftCodeToken = route.paramMap.get('giftCodeToken');
    const getGiftCode$ = this.giftsService.getGiftCode(giftCodeToken);
    const getGiftDetails$ = this.giftsService.getGiftReservationDetails(giftCodeToken);

    return getGiftCode$
      .pipe(
        switchMap((giftCode: IGiftCode) => {
          let next$ = of<IGiftRedeem | null>(null);
          switch (giftCode.giftCodeAssignmentStatus) {
            case GiftCodeAssignmentStatus.Success:
              next$ = getGiftDetails$
                .pipe(
                  map((giftDetails: IGift) => ({ giftCode, giftDetails })),
                  catchError(_err => of(null)));
              break;

            default:
              next$ = of({ giftCode, giftDetails: null });
              break;
          }
          return next$;
        }),
        catchError(_err => of(null))
      );
  }

}
